import { message } from 'ant-design-vue'
import { hasPermission } from './permission'

/**
 * 路由级权限校验
 * meta.permission 统一为 ntc_role 数组（如 ['admin', 'dev']），未配置表示登录即可访问
 * 权限单一来源：后端 GET /user/config 返回的 ntc_role
 */
function hasRoutePermission(route) {
  if (route.meta && route.meta.permission) {
    return hasPermission(route.meta.permission)
  }
  return true
}

function filterAsyncRoutes(routes) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (hasRoutePermission(tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children)
      }
      res.push(tmp)
    }
  })

  return res
}

function copy(value) {
  if (!value) return
  if (typeof value === 'object') {
    try {
      value = JSON.stringify(value)
    } catch (_err) {
      console.warn('复制出错：', _err)
    }
  }
  const copyInput = document.createElement('input')
  document.body.appendChild(copyInput)
  copyInput.setAttribute('value', value)
  copyInput.select()
  document.execCommand('Copy')
  message.success('复制成功')
  copyInput.remove()
}

export { filterAsyncRoutes, copy }
